import { useState, useEffect } from "react";
import { SwalAlertClass } from "core/swalClass";

import axiApi from "ApiCaller";

const CountAssets = {
    has: 0,
    out: 0
}
const CountMeasures = {
    down: 0,
    middle: 0,
    up: 0
}
const CountRoutes = {
    dinamic: 0,
    static: 0
}
const SumaryDataWaste = (props) => {
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar", });
    const [assets, setAssets] = useState(CountAssets);
    const [measures, setMeasures] = useState(CountMeasures);
    const [routes, setRoutes] = useState(CountRoutes);

    useEffect(() => {
        axiApi.get("/api/home/sumary/")
            .then((resp) => {
                if (resp.data.status) {
                    setAssets(resp.data.assets);
                    setMeasures(resp.data.measures);
                    setRoutes(resp.data.routes);
                } else {
                    Alert.error(
                        "Server Error",
                        "Se ha encontrado un error en la carga del mapa."
                    )
                }
            })
            .catch((error) => {
                console.log(error)
                Alert.error(
                    "Server Error",
                    "Se ha encontrado un error en la carga del mapa."
                )
            })
    }, [])
    return (
        <div className="d-flex flex-row justify-content-between flex-flow-wrap gap-2">
            <div className="text-success border text-center w-100">
                <h1>{assets.has} / {assets.out}</h1>
                <small>Contenedores con / sin sensor</small>
            </div>
            <div className="text-success border text-center w-100">
                <h1>
                    <span className="text-success">{measures.down}</span>
                    <span className="text-black-50"> / </span>
                    <span className="text-warning">{measures.middle}</span>
                    <span className="text-black-50"> / </span>
                    <span className="text-danger">{measures.up}</span>
                </h1>
                <small>Contenedores &lt;50%, 50%-80% y &gt;80%</small>
            </div>
            <div className="text-blue border text-center w-100">
                <h1>
                    <span>{routes.static}</span>
                    <span> / </span>
                    <span>{routes.dinamic}</span>
                </h1>
                <small>Número de rutas estáticas y dinámicas</small>
            </div>
        </div>

    );
}

export default SumaryDataWaste;
